export const Hidden = (props) => {
    const {children} = props
    return <div style={{
        visibility: "hidden"
    }}>
        {children}
    </div>
}